import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-content.scss";
import {Resources} from "../../../../../resources/Resources";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {WebsiteBlackStepsComponent} from "../black/steps/WebsiteBlackStepsComponent";
import {WebsiteBlackPresentationComponent} from "../black/presentation/WebsiteBlackPresentationComponent";
import {WebsiteBlackTextComponent} from "../black/text/WebsiteBlackTextComponent";
import {WebsiteBlackDivideComponent} from "../black/divide/WebsiteBlackDivideComponent";
import {WebsiteBlackUnionLineComponent} from "../black/union/line/WebsiteBlackUnionLineComponent";
import {Network} from "../../../../../network/Network";

export class WebsiteContentAutopilotComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPresentationComponent({
                            startText: Resources.t("words.beginFree"),
                            title: Resources.t("words.automateBlogManagement"),
                            description: Resources.t("words.aiHandlesEverything"),
                            people: false,
                            center: true,
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackStepsComponent({
                            center: true,
                            contents: [
                                {
                                    name: Resources.t("words.autopilotConfiguration"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-ba.mp4"),
                                    duration: 10000
                                }
                            ]
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackTextComponent({
                            text: Resources.t("words.pilotAutoPublishingDescription"),
                            size: "sizeBig",
                        }))}
                        ${this.draw(new WebsiteBlackUnionLineComponent())}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackDivideComponent({
                            what: Resources.t("words.pilotWhatIsIt"),
                            title: Resources.t("words.pilotTitle"),
                            divide: Resources.t("words.pilotHowItWorks"),
                            grid: {
                                lines: [{
                                    entries: [{
                                        step: 1,
                                        title: Resources.t("words.pilotStepDescribeBusiness"),
                                        description: Resources.t("words.pilotStepDescribeBusinessDescription"),
                                        type: "icon",
                                        icon: "plan",
                                        size: "sizeMid",
                                        color: "colorWhite",
                                        shadowPosition: "shadowNone"
                                    }, {
                                        step: 2,
                                        title: Resources.t("words.pilotStepBrandTone"),
                                        description: Resources.t("words.pilotStepBrandToneDescription"),
                                        type: "icon",
                                        icon: "tone",
                                        size: "sizeMid",
                                        color: "colorWhite",
                                        shadowPosition: "shadowLeftCenter"
                                    }]
                                }, {
                                    entries: [{
                                        step: 3,
                                        title: Resources.t("words.pilotStepSeoAnalysis"),
                                        description: Resources.t("words.pilotStepSeoAnalysisDescription"),
                                        type: "icon",
                                        icon: "seo",
                                        size: "sizeMid",
                                        color: "colorWhite",
                                        shadowPosition: "shadowBottomCenter"
                                    }, {
                                        step: 4,
                                        title: Resources.t("words.pilotStepCompetitiveAnalysis"),
                                        description: Resources.t("words.pilotStepCompetitiveAnalysisDescription"),
                                        type: "icon",
                                        icon: "chart",
                                        size: "sizeMid",
                                        color: "colorWhite",
                                        shadowPosition: "shadowNone"
                                    }]
                                }, {
                                    entries: [{
                                        step: 5,
                                        title: Resources.t("words.pilotStepContentCreation"),
                                        description: Resources.t("words.pilotStepContentCreationDescription"),
                                        type: "icon",
                                        icon: "write",
                                        size: "sizeMid",
                                        color: "colorWhite",
                                        shadowPosition: "shadowBottomCenter",
                                        button: Resources.t("words.pilotLearnMore"),
                                        buttonLink: Network.router.pages.getUrlWithPath('editor')
                                    }, {
                                        step: 8,
                                        title: Resources.t("words.pilotStepContentPublishing"),
                                        description: Resources.t("words.pilotStepContentPublishingDescription"),
                                        type: "icon",
                                        icon: "ready",
                                        size: "sizeMid",
                                        color: "colorYellow",
                                        shadowPosition: "shadowLeftCenter"
                                    }]
                                }]
                            }
                        }))}
                    </div>
                </div>
            </div>
        `;
    }
}